import { Button, Input } from '@nextui-org/react'
import React, { useState } from 'react'
import logo from '../../assets/images/logo_klhk.png'
import { useForm } from 'react-hook-form';
import { EnvelopeIcon, EyeIcon, EyeSlashIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import login from '../../assets/banner/bg-login-mercury.jpg'
import { isResponseErrorObject } from '../../services/helpers';
import { postFetcherMotivasiMerkuri } from '../../services/api';
import Cookies from 'js-cookie';

export default function LoginMercuryMotivation() {
    const [isVisible, setIsVisible] = useState(false);
    const [loginError, setLoginError] = useState(""); // State untuk error message
    const { register, handleSubmit, formState: { errors, isSubmitting }, } = useForm();

    function toggleVisibility() {
        setIsVisible(!isVisible);
    }

    async function onSubmit(form) {
        setLoginError("");
        try {
            const response = await postFetcherMotivasiMerkuri('api/login', form);
            if (!response.data?.auth_token) {
                setLoginError("Login gagal. Silakan coba lagi.");
                return;
            }
            // Simpan cookie secara manual menggunakan document.cookie
    
            window.location.href = 'https://motivasimerkuri.menlhk.go.id/dashboard';
        } catch (error) {
            if (isResponseErrorObject(error?.response?.data?.message)) {
                const firstError = Object.values(error?.response?.data?.message)[0];
                setLoginError(firstError);
            } else {
                setLoginError(error?.response?.data?.message || "Login gagal. Silakan coba lagi." + error);
            }
        }
    }

    return (
        <section key="banner" className='relative w-full h-screen mx-auto'>
                <div className='absolute inset-0'>
                    <img alt="bg-login" src={login} className="w-full h-full object-cover opacity-40" />
                </div>
                
                <div className="w-full h-full relative z-10 flex flex-col items-center justify-center">
                    <div className='max-w-screen-sm mx-auto py-10 xl:py-0 px-3 md:px-10'>
                        <div className='flex flex-col items-center'>
                            <img src={logo} alt="Logo" className="size-24" />
                        </div>
                        <div className="rounded-2xl bg-white shadow-xl">
                            <form action="" className="lg:p-11 p-7 text-start" onSubmit={handleSubmit(onSubmit)}>
                                <div className="mb-11 text-center">
                                    <h1 className="text-ink-900 text-center font-manrope text-2xl font-bold leading-10 mb-2">Login Motivasi Merkuri</h1>
                                    <span className='text-sm'>Monitoring dan Evaluasi Terintegrasi Pencapaian Pengurangan dan Penghapusan Merkuri</span>
                                </div>
                                <Input
                                    {...register('email', { required: "Email harus diisi" })}
                                    radius="sm"
                                    className="pb-5"
                                    type="text"
                                    size="lg"
                                    color={errors.email ? 'danger' : 'default'}
                                    placeholder="Email"
                                    startContent={<EnvelopeIcon className="size-5" />}
                                    isInvalid={errors.email}
                                    errorMessage={errors.email && errors.email.message}
                                />
                                <Input
                                    {...register('password', { required: "Password harus diisi" })}
                                    radius="sm"
                                    className="pb-5"
                                    type={isVisible ? "text" : "password"}
                                    size="lg"
                                    color={errors.password ? 'danger' : 'default'}
                                    placeholder="Password"
                                    startContent={<LockClosedIcon className="size-5" />}
                                    endContent={
                                        <Button isIconOnly onClick={toggleVisibility}>
                                            {isVisible ? <EyeSlashIcon className="size-5" /> : <EyeIcon className="size-5" />}
                                        </Button>
                                    }
                                    isInvalid={errors.password}
                                    errorMessage={errors.password && errors.password.message}
                                />
                                <Button
                                    isLoading={isSubmitting}
                                    isDisabled={isSubmitting}
                                    type='submit'
                                    radius="sm"
                                    color="primary"
                                    className="w-full text-lg py-5"
                                >
                                    Masuk
                                </Button>

                                {/* Menampilkan pesan error login */}
                                {loginError && <p className="text-danger text-sm mt-3 text-center">{loginError}</p>}
                            </form>
                        </div>
                    </div>
                </div>
        </section>
    )
}
